export interface CategoryMeta {
  key: string;
  name: string;
  icon: string;
  intro: string;
}

export const categories: CategoryMeta[] = [
  {
    key: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    intro: '汇聚院线热映、口碑佳作与经典高分电影，涵盖剧情、科幻、悬疑、动作、爱情等多种类型。',
  },
  {
    key: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    intro: '精选海内外热播剧集，涵盖古装权谋、都市情感、悬疑推理、青春治愈等丰富题材，追剧不迷路。',
  },
  {
    key: 'variety',
    name: '综艺',
    icon: 'ri-mic-line',
    intro: '汇集户外竞技、音乐选秀、美食旅行、益智挑战等热门综艺节目，轻松欢乐陪你度过休闲时光。',
  },
];

export const yearOptions: string[] = ['全部', '2025', '2024', '2023', '2022'];

export const regionOptions: string[] = ['全部', '中国大陆', '中国香港', '美国', '韩国', '英国'];

export const sortOptions: string[] = ['最新', '最热', '评分'];

export const genreOptions: string[] = [
  '全部',
  '剧情',
  '悬疑',
  '科幻',
  '爱情',
  '动作',
  '犯罪',
  '冒险',
  '历史',
  '都市',
  '家庭',
  '综艺',
  '美食',
  '音乐',
  '旅行',
];